
var blob_error_renderer={};

module.exports.update_button_visibility = (application_context)=>{
    let ary_page_transition = application_context.ary_page_transition;
    let page = application_context.page;

    let has_next;
    let has_prev;

    has_next = (ary_page_transition[page].next !== null);
    has_prev = (ary_page_transition[page].prev !== null);

    if(!has_next && !has_prev){
        application_context.DOM.button_go_prev.classList.add("invisible");
        application_context.DOM.button_go_next.classList.add("invisible");
        

    } else if(has_next && !has_prev) {
        application_context.DOM.button_go_prev.classList.add("invisible");
        application_context.DOM.button_go_next.classList.remove("invisible");
        
        
    } else if(!has_next && has_prev){
        application_context.DOM.button_go_prev.classList.remove("invisible");
        application_context.DOM.button_go_next.classList.add("invisible");
        

    } else if(has_next && has_prev){
        application_context.DOM.button_go_prev.classList.remove("invisible");
        application_context.DOM.button_go_next.classList.remove("invisible");
        
    }
}

module.exports.disable_next = (application_context)=>{
    application_context.DOM.button_go_next.disabled=true;
}
module.exports.enable_next = (application_context)=>{
    application_context.DOM.button_go_next.disabled=false;
}

module.exports.change_close_button_title = (application_context)=>{
    application_context.DOM.button_close.innerHTML="閉じる";
}

module.exports.clear_error = (option={}) =>{

    let page;
    ({page:page} = option);

    if(page === void(0)) return;

    ary_DOM_message_container=document.querySelectorAll(`[data-page="${page}"] [data-message-field]`);

    for(let DOM_message_container of ary_DOM_message_container){
        DOM_message_container.innerHTML="";
    }
}

/**
 * ベリファイエラー、リクエストエラーを画面に表示する
 * 実際の表示は
 * @param {*} blob_verify_error 
 */
module.exports.render_error=(blob_error)=>{
    if(blob_error.code in blob_error_renderer){
        let render_func;
        render_func = blob_error_renderer[blob_error.code];
        render_func.call(null,blob_error);
    }
    
}

module.exports.render_verify_error=(blob_verify_error)=>{
    //現在は、同関数のエイリアスとして実装
    module.exports.render_error(blob_verify_error);
}
module.exports.render_request_error=(blob_request_error)=>{
    //現在は、同関数のエイリアスとして実装
    module.exports.render_error(blob_request_error);
}

/**
 * 
 * @param {*} blob_error 
 * @returns 
 * @note
 * blob_verify_errorの中身を解釈して、htmlまたはテキストを生成、
 * DOM_message_containerに対応する要素内に挿入する。
 * 
 * レンダーハンドラを新たに作る場合のサンプルとしてデフォルト処理を実装
 * もし、処理として十分であればこのハンドラを使用できる。
 * 
 */
module.exports.default_error_rederer=(blob_error)=>{
    let DOM_message_container;
    
    DOM_message_container=document.querySelector(`[data-message-field][data-code="${blob_error.code}"]`);
    if(DOM_message_container === null) return;

    // 実装の決まりとしてベリファイコードが判明した時点で、どのようにテキスト(html)化するかわかっている
    
    let message;
    message=`${blob_error.data.description}`;

    DOM_message_container.innerHTML=message;
}

/**
 * レンダーハンドラを登録する
 * @param {*} code ベリファイコードまたはリクエストエラーコード
 * @param {*} render_func レンダーハンドラ
 * 
 * @note
 * レンダーハンドラは次の形式の関数。
 * function(blob_error){
 * 
 *   //
 *   // この関数の役目は
 *   // フォームまたはバックエンドが返したベリファイ/リクエストエラー
 *   // を画面上に表示すること。
 * 
 *   //blob_errorの例：
 *   //blob_error = {
 *   //  code:"b4faa47b-7489-4956-b145-02ae4e79d438",
 *   //  // 注意：レンダーハンドラが正しく表示できる限り、dataの内容は自由。
 *   //  // ただし、1つのベリファイコードに対し1つのレンダーハンドラしか設定できないことに留意が必要
 *   //  data:{
 *   //    field_name:"accept_term",
 *   //    description:`内部エラーです。`
 *   //  }
 *   //} 
 * }
 */
module.exports.register_error_rederer = (code,render_func) =>{

    let is_render_func_valid;
    let is_code_valid;
    is_render_func_valid = (render_func && typeof render_func === 'function');
    // NOTE:簡易実装
    is_code_valid = (typeof code === 'string' || code instanceof String);

    if(is_render_func_valid){
        blob_error_renderer[code] = render_func;
    }

}

module.exports.register_verify_error_rederer = (verify_code,render_func) =>{
    //現在は、同関数のエイリアスとして実装
    module.exports.register_error_rederer(verify_code,render_func);
}
module.exports.register_request_error_rederer = (verify_code,render_func) =>{
    //現在は、同関数のエイリアスとして実装
    module.exports.register_error_rederer(verify_code,render_func);
}
